export default {
	title: "Entrar como Membro",
	enterCode: "Digite o código de convite que você recebeu",
	code: "Código de Convite",
	validate: "Validar Código",
	invalidCode: "Código inválido ou expirado",
	createAccount: "Criar sua Conta",
	joiningTemple: "Você está entrando no templo: {temple}",
	invitedTo: "Você foi convidado para este templo",
	displayName: "Nome Completo",
	ritualFunction: "Função no Templo",
	ritualFunctionHint: "Ex: Médium, Cambono, Ogã (opcional)",
	submit: "Criar Conta",
	acceptInvite: "Aceitar Convite",
	acceptAndJoin: "Aceitar e Entrar no Templo",
	loggedInAs: "Você está logado como {name} ({email})",
	error: "Erro ao criar conta. Tente novamente.",
};
